import React from 'react';
import FootnotesListItem from './FootnotesListItem';

const FootnotesList = props => {
  const { footnotes } = props;

  return (
    <ol>
      { footnotes.map( (footnote, index) => <FootnotesListItem footnote={footnote} key={index}/> ) }
    </ol>
  )
}

export default FootnotesList;


// WEBPACK FOOTER //
// ./src/components/FootnotesList.js